/**
 * @generated SignedSource<<4f318c383a24d532482a50b73cee2d7e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SignalWorkspaceTemplateSelectorDeleteTemplateMutation$variables = {
  templateId: string;
};
export type SignalWorkspaceTemplateSelectorDeleteTemplateMutation$data = {
  readonly signalWorkspaceTemplate: {
    readonly deleteTemplate: {
      readonly id: string;
    };
  };
};
export type SignalWorkspaceTemplateSelectorDeleteTemplateMutation = {
  response: SignalWorkspaceTemplateSelectorDeleteTemplateMutation$data;
  variables: SignalWorkspaceTemplateSelectorDeleteTemplateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "templateId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "templateId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SignalWorkspaceTemplateSelectorDeleteTemplateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SignalWorkspaceTemplateMutation",
        "kind": "LinkedField",
        "name": "signalWorkspaceTemplate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SignalWorkspaceTemplate",
            "kind": "LinkedField",
            "name": "deleteTemplate",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SignalWorkspaceTemplateSelectorDeleteTemplateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SignalWorkspaceTemplateMutation",
        "kind": "LinkedField",
        "name": "signalWorkspaceTemplate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SignalWorkspaceTemplate",
            "kind": "LinkedField",
            "name": "deleteTemplate",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteRecord",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0b65a898e639c497e6f555a49c3b6a75",
    "id": null,
    "metadata": {},
    "name": "SignalWorkspaceTemplateSelectorDeleteTemplateMutation",
    "operationKind": "mutation",
    "text": "mutation SignalWorkspaceTemplateSelectorDeleteTemplateMutation(\n  $templateId: ID!\n) {\n  signalWorkspaceTemplate(id: $templateId) {\n    deleteTemplate {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3636208fd5dbee4358537ee9dfd3c780";

export default node;
